import audioLinesIcon from '@/media/icons/audio-lines.svg';
import serviceDeskIcon from '@/media/icons/service-desk.svg';

import type { IAdditionalPND } from './components/App/NewOrder/offer-step/types/bcc.types';
import altynLogo from './media/icons/altyn_logo.png';
import bckLogo from './media/icons/bck_Logo.png';
import berekeLogo from './media/icons/bereke_logo.png';
import check from './media/icons/check.svg';
import eurasLogo from './media/icons/euras_logo.png';
import fileDownload from './media/icons/file-download.svg';
import forteLogo from './media/icons/forte_logo.png';
import freedomlogo from './media/icons/freedom_Logo.png';
import halykLogo from './media/icons/halyk_logo.png';
import kmfLogo from './media/icons/kmf_logo.png';
import nur from './media/icons/nur.svg';
import phone from './media/icons/phone.svg';
import questionIcon from './media/icons/question-circle-outlined.png';
import shieldUserLogo from './media/icons/shield-user.svg';
import shinHanLogo from './media/icons/shinhan-bank.png';
import logoBg from './media/login_bg.jpg';
import expandLogo from './media/logo_expand.png';

export const checkIcon = check;
export const fileDownloadIcon = fileDownload;
export const pathExpandLogo = expandLogo;
export const pathLogoBg = logoBg;
export const pathQuestionicon = questionIcon;
export const pathServiceDeskIcon = serviceDeskIcon;
export const pathAudioLinesIcon = audioLinesIcon;
export const phoneIcon = phone;
export const pathShieldUserLogo = shieldUserLogo;

export enum Languages {
  kz = 'kz',
  ru = 'ru',
  en = 'en'
}
export const SUPPORTED_LANGUAGES = [Languages.kz, Languages.ru, Languages.en];

// P.s. После изменения, нужно проверить функцию fillDictExtras в src/services/helpers/dict.ts
export enum DictTypes {
  AddContactsIsRelated = 'Add_Contacts_Is_Related', // Кем приходится
  AutoTypes = 'Auto_Types', // Тип авто
  Banks = 'Banks', // Интегрированные Банки
  Brands = 'Brands', // Марка
  Cities = 'Cities', // Список всех городов
  Colors = 'Colors', // Цвет авто
  CompanyActivityTypes = 'Company_Activity_Types', // Сфера деятельности организации
  Countries = 'Countries', // Страны
  Dealers = 'Dealers', // Диллеры
  DealersBrands = 'Dealers_Brands', // Дилерские бренды
  DealersCities = 'Dealers_Cities', // Список городов по активным дилерам
  DealersTypes = 'Dealers_Types', // Типы ДЦ
  DealersUsedDealers = 'Dealers_Used_Dealers', // Дилеры привязанные к дилерам
  DocumentIssuringAuthorities = 'Document_Issuing_Authorities', // Кем выдан
  DocumentTypes = 'Document_Types', // Тип документа
  DriveTypes = 'Drive_Types', // Тип привода
  EducationTypes = 'Education_Types', // Образование
  EngineTypes = 'Engine_Types', // Тип двигателя
  Equipments = 'Equipments', // Комплектации
  FaqPagesTypes = 'Faq_Pages_Types', // Типы страниц FAQ
  GearboxTypes = 'Gearbox_Types', // Тип коробки
  Genders = 'Genders', // Пол
  InsuranceInstallmentPeriods = 'Insurance_Installment_Periods', // Период рассрочки
  InsuranceInstallmentTypes = 'Insurance_Installment_Types', // Тип оплаты
  InsurancePaymentTypes = 'Insurance_Payment_Types', // Cпособ оплаты
  Insurances = 'Insurances', // Страховые компании
  IntegrationTypes = 'Integration_Types', // Тип интеграции
  LeasingCompanies = 'Leasing_Companies', // Лизинговые компании
  LeasingIndividualsSettings = 'Leasing_Individuals_Settings', // Связи физ. лизинговых компаний
  LoanTerms = 'Loan_Terms', // Срок займа
  MainActivities = 'Main_Activities', // Основной вид деятельности
  MaritalStatuses = 'Marital_Statuses', // Семейное положение
  Models = 'Models', // Модель
  Modules = 'Modules', //  Модули
  ModulesSupportCategories = 'Modules_Support_Categories', // Связка модулей с категориями обращения в поддержку
  OnlineRequestFcStatuses = 'Online_Request_FC_Statuses', // Статусы онлайн-заявок
  OrganizationTypes = 'Organization_Types', // Вид организации
  PaymentDates = 'Payment_Dates', // Дата платежа
  PoscredBankProducts = 'Poscred_Bank_Products', // Продукт БВУ
  PoscredProducts = 'Poscred_Products', // Тип Pos-cred продуктов
  Positions = 'Positions', // Должности
  Products = 'Products', // Продукты (StockBoundaries)
  ProductsTypes = 'Product_Types', // Типы продуктов
  PropertyTypes = 'Property_Types', // Вид собственности
  RepaymentTypes = 'Repayment_Types', // Схема оплаты
  ResidentStatuses = 'Resident_Statuses', // Статус резидента
  SalePoints = 'Sale_Points', // Точки продаж
  SocialStatuses = 'Social_Statuses', // Социальный статус
  Statuses = 'Statuses', // Статусы
  SupportCategories = 'Support_Categories', // Категории обращения в поддержку
  SupportReasons = 'Support_Reasons', // Причина обращения / причина отмены
  SupportTemplates = 'Support_Templates', // Шаблоны обращений в поддержку
  VehicleRegistrationCompanies = 'Vehicle_Registration_Companies',
  Years = 'Years' // Год выпуска,
}

export const statusColors = {
  draft: {
    bgColor: '#313A49',
    textColor: 'white'
  },
  created: {
    bgColor: '#313A49',
    textColor: 'white'
  },
  approved: {
    bgColor: '#0CAF60',
    textColor: 'white'
  },
  client_accepted: {
    bgColor: '#EAFFF1',
    textColor: '#0CAF60'
  },
  completed: {
    bgColor: '#0CAF60',
    textColor: 'white'
  },
  declined: {
    bgColor: '#E03137',
    textColor: 'white'
  },
  waiting_bank_response: {
    bgColor: '#FFD023',
    textColor: 'black'
  },
  add_queue: {
    bgColor: '#FFD023',
    textColor: 'black'
  },
  waiting_of_payment: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  error: {
    bgColor: '#FF2E1F',
    textColor: 'white'
  },
  bank_response_timeout: {
    bgColor: '#FF2E1F',
    textColor: 'white'
  },
  financed: {
    bgColor: '#0CAF60',
    textColor: 'white'
  },
  cancelled: {
    bgColor: '#FF2E1F',
    textColor: 'white'
  },
  waiting_of_financing: {
    bgColor: '#1f9aff',
    textColor: 'white'
  },
  waiting_for_docs_confirmation: {
    bgColor: '#1f9aff',
    textColor: 'white'
  },
  waiting_for_upload_files: {
    bgColor: '#1f9aff',
    textColor: 'white'
  },
  vehicle_registration: {
    bgColor: '#1f9aff',
    textColor: 'white'
  },
  accepted_alternative: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  on_rework: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  on_verification: {
    bgColor: '#FFD023',
    textColor: 'black'
  },
  financed_pledge_missing: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  sms_verificating: {
    bgColor: '#023D3D',
    textColor: 'white'
  },
  pre_approved: {
    bgColor: '#0CAF60',
    textColor: 'white'
  },
  mobile_client: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  financed_waiting_for_modification_before_pledge: {
    bgColor: '#1F9AFF',
    textColor: 'white'
  },
  refund_in_progress: {
    bgColor: '#a8a8a8',
    textColor: 'white'
  },
  refunded: {
    bgColor: '#a8a8a8',
    textColor: 'white'
  }
};

export enum BankNames {
  altyn = 'altyn',
  bcc = 'bcc',
  bereke = 'bereke',
  euBank = 'eu_bank',
  euBankV2 = 'eu_bank_v2',
  ffb = 'ffb',
  forte = 'forte',
  halyk = 'halyk',
  kmf = 'kmf',
  mfo = 'mfo',
  sapa = 'sapa',
  shinhan = 'shinhan',
  solva = 'solva'
}

export const BCC_PRODUCTS: Record<IAdditionalPND['code'], string> = {
  insurance: 'Страхование',
  not_insurance: '',
  susp: 'Отлагательные условия'
};

export const BANKS_COLORS: Record<BankNames, string> = {
  [BankNames.altyn]: '#E21F25',
  [BankNames.bcc]: '#DAAB6B',
  [BankNames.bereke]: '#6F873E',
  [BankNames.euBankV2]: '#FF006E',
  [BankNames.euBank]: '#FF006E',
  [BankNames.ffb]: '#76B949',
  [BankNames.forte]: '#4a0221',
  [BankNames.halyk]: '#00805F',
  [BankNames.kmf]: '#D4310F',
  [BankNames.mfo]: '#76B949',
  [BankNames.sapa]: '#1eae9e',
  [BankNames.shinhan]: '#0046FF',
  [BankNames.solva]: '#f51047'
};

export const BANKS_ICONS_NAMES: Partial<
  Record<BankNames | 'nur', { name: string; icon: string } | undefined>
> = {
  altyn: { name: 'Алтын Банк', icon: altynLogo },
  bcc: { name: 'Банк Центр Кредит', icon: bckLogo },
  bereke: { name: 'Береке Банк', icon: berekeLogo },
  eu_bank: { name: 'Банк Евразийский', icon: eurasLogo },
  eu_bank_v2: { name: 'Банк Евразийский', icon: eurasLogo },
  ffb: { name: 'Freedom Bank', icon: freedomlogo },
  forte: { name: 'Forte Bank', icon: forteLogo },
  halyk: { name: 'Халык Банк', icon: halykLogo },
  kmf: { name: 'KMF', icon: kmfLogo },
  solva: { name: 'Solva', icon: '' },
  nur: { name: '', icon: nur },
  sapa: { name: 'SAPA', icon: '' },
  shinhan: { name: 'Shinhan Банк', icon: shinHanLogo }
};

export const WIDTH_FOR_OPENED_NAVBAR = 1340;

export const SELECTED_BANK_STATUSES = [
  'financed',
  'waiting_of_financing',
  'on_rework',
  'financed_pledge_missing',
  'waiting_for_upload_files',
  'financed_waiting_for_modification_before_pledge',
  'mobile_client',
  'vehicle_registration',
  'refund_in_progress',
  'refunded',
  'waiting_for_docs_confirmation'
];

export const SYMBOLS = {
  longDash: '\u2014', // —
  tenge: '\u20B8' // ₸
};

export const MODULE_CODES = {
  autoCredit: 'auto-credit',
  clients: 'clients',
  insurances: 'insurances',
  leads: 'leads',
  leasing: 'leasing',
  main: 'main',
  posCredit: 'pos-credit',
  reports: 'reports',
  security: '$security$'
} as const;

export const SERVICE_DESK_TEMPLATE_CUSTOM_OPTION = 'Другое';

export enum ServiceDeskTemplateTypes {
  text = 'text',
  iin = 'iin',
  num = 'num',
  phoneNum = 'phoneNum',
  textarea = 'textarea',
  select = 'select'
}

export const SERVICE_DESK_TEMPLATE_TYPE_NAMES: Record<
  ServiceDeskTemplateTypes,
  string
> = {
  [ServiceDeskTemplateTypes.text]: 'Текст',
  [ServiceDeskTemplateTypes.iin]: 'ИИН',
  [ServiceDeskTemplateTypes.num]: 'Цифры',
  [ServiceDeskTemplateTypes.phoneNum]: 'Номер телефона',
  [ServiceDeskTemplateTypes.textarea]: 'Текст (многострочный)',
  [ServiceDeskTemplateTypes.select]: 'Выбор'
};

export enum SecurityStatus {
  fraud = 'declined',
  notEnoughData = 'on_review',
  notVerified = 'draft',
  verified = 'approved'
}

export const SecurityStatusLabels: Record<SecurityStatus, string> = {
  [SecurityStatus.fraud]: 'Мошенничество',
  [SecurityStatus.notEnoughData]: 'Данных недостаточно',
  [SecurityStatus.notVerified]: 'Не проверено',
  [SecurityStatus.verified]: 'Проверка пройдена'
};

export const CREATE_ROUTE_NAME = 'create';

export const PHONE_NUMBER_REGEX = /\+\d \(\d\d\d\) \d\d\d-\d\d-\d\d/;

export const PRIVACY_POLICY_LINK =
  'https://storage.yandexcloud.kz/allurfin-public/privacy_policy.pdf';
export const CONSENT_TO_THE_PROCESSING_OF_PERSONAL_DATA_LINK =
  'https://storage.yandexcloud.kz/allurfin-public/consent_to_the_processing_of_personal_data.pdf';
export const TERMS_OF_PURCHASE_OF_ADDITIONAL_PRODUCTS_AND_SERVICES_LINK =
  'https://storage.yandexcloud.kz/allurfin-public/terms_of_purchase_of_additional_products_and_services.pdf';

export const LEASING_STATUSES = {
  financed: {
    color: '#FFF',
    bgColor: '#0CAF60'
  },
  approved: {
    color: '#FFF',
    bgColor: '#0CAF60'
  },
  declined: {
    color: '#FFF',
    bgColor: '#FF2E1F'
  },
  on_review: {
    color: '#111827',
    bgColor: '#FFD023'
  },
  waiting_of_financing: {
    color: '#FFF',
    bgColor: '#1f9aff'
  },
  leasing_created: {
    color: '#FFF',
    bgColor: '#323B49'
  },
  leasing_draft: {
    color: '#A0AEC0',
    bgColor: '#F1F2F4'
  },
  not_sent: {
    color: '#111827',
    bgColor: '#323B49'
  },
  archive: {
    color: '#A0AEC0',
    bgColor: '#F1F2F4'
  },
  client_accepted: {
    color: '#FFF',
    bgColor: '#0CAF60'
  },
  waiting_bank_response: {
    color: '#111827',
    bgColor: '#FFD023'
  }
} as const satisfies Record<string, { color: string; bgColor: string }>;

export enum EGrnFactoryCheckResult {
  PENDING = 'PENDING',

  SKIPPED = 'SKIPPED',
  SKIPPED_SAPA = 'SKIPPED_SAPA',

  MISMATCHED = 'MISMATCHED',
  UNABLE_TO_CHECK = 'UNABLE_TO_CHECK',

  MATCHED = 'MATCHED',
  MANUALLY_CONFIRMED = 'MANUALLY_CONFIRMED'
}
